(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Service = App.loadClass('core::Angular/Service');

  exports.ReportService = (function(superClass) {
    extend(ReportService, superClass);

    function ReportService(http, window) {
      this.http = http;
      this.window = window;
      this._getLayerIdsFromSelections = bind(this._getLayerIdsFromSelections, this);
      this.launchPsr = bind(this.launchPsr, this);
      this.getSurveyDetails = bind(this.getSurveyDetails, this);
      this.getPlanDetails = bind(this.getPlanDetails, this);
      this.getDuplicateFields = bind(this.getDuplicateFields, this);
      this.getSurveyResults = bind(this.getSurveyResults, this);
      this.getYearsAndSpps = bind(this.getYearsAndSpps, this);
      return;
    }

    ReportService.prototype.getYearsAndSpps = function() {
      return this.http.post('backend/grower/placement/report/get-years-and-spps');
    };

    ReportService.prototype.getSurveyResults = function(years, spps) {
      var params;
      params = {
        years: years,
        spp_ids: spps.map(function(spp) {
          return spp.id;
        })
      };
      return this.http.post('backend/grower/placement/report/get-survey-results', params);
    };

    ReportService.prototype.getDuplicateFields = function(survey_results) {
      var params;
      params = {
        survey_result_ids: survey_results.map(function(survey_result) {
          return survey_result.id;
        })
      };
      return this.http.post('backend/grower/placement/report/get-duplicate-fields', params);
    };

    ReportService.prototype.getPlanDetails = function(survey_result, field) {
      var params;
      params = {
        survey_result_id: survey_result.id,
        field_id: field.id
      };
      return this.http.post('backend/grower/placement/report/get-plan-details', params);
    };

    ReportService.prototype.getSurveyDetails = function(survey_result, field) {
      var params;
      params = {
        survey_result_id: survey_result.id,
        field_id: field.id
      };
      return this.http.post('backend/grower/placement/report/get-survey-details', params);
    };

    ReportService.prototype.launchPsr = function(selections, ui) {
      var params;
      ui.loading = true;
      ui.buttonText = 'Generating Report...';
      params = {
        layer_ids_by_year: this._getLayerIdsFromSelections(selections),
        send_email: true
      };
      selections.downloading = true;
      return this.http.post('backend/grower/placement/report/generate-psr', params).then((function(_this) {
        return function(result) {
          var response;
          selections.downloading = false;
          ui.loading = false;
          ui.buttonText = 'Next';
          response = result.data;
          params = $.param({
            file: response.data.file,
            file_name: response.data.file_name
          });
          return _this.window.open("backend/grower/placement/report/show-psr?" + params);
        };
      })(this), function() {
        return selections.downloading = false;
      });
    };

    ReportService.prototype._getLayerIdsFromSelections = function(selections) {
      var arr, dup, field_id, i, layer_id, layer_ids_by_year, len, name, name1, ref, ref1, sr;
      layer_ids_by_year = {};
      ref = selections.survey_results;
      for (i = 0, len = ref.length; i < len; i++) {
        sr = ref[i];
        ref1 = sr.planned_fields;
        for (field_id in ref1) {
          layer_id = ref1[field_id];
          dup = _.find(selections.duplicate_fields, {
            id: parseInt(field_id)
          });
          if (dup != null) {
            arr = dup.survey_results[sr.year];
            if ((arr == null) || indexOf.call(arr, sr) >= 0 || arr.length === 0) {
              if (layer_ids_by_year[name = sr.year] == null) {
                layer_ids_by_year[name] = [];
              }
              layer_ids_by_year[sr.year].push(layer_id);
            }
          } else {
            if (layer_ids_by_year[name1 = sr.year] == null) {
              layer_ids_by_year[name1] = [];
            }
            layer_ids_by_year[sr.year].push(layer_id);
          }
        }
      }
      return layer_ids_by_year;
    };

    return ReportService;

  })(Service);

}).call(this);
